export default __webpack_public_path__ + "static/media/Principe.62d5ba28.jpg";